import { useState, useEffect } from 'react';
import { getAbsenceAlerts } from '../../../../services/absenceService';
import { StudentAlert } from '../../../../types/absenceTypes';

export const useAlertStudents = (limit?: number) => {
  const [alerts, setAlerts] = useState<StudentAlert[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        setLoading(true);
        const response = await getAbsenceAlerts(limit);
        setAlerts(response.data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch student alerts');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAlerts();
  }, [limit]);

  return { alerts, loading, error };
};

export default useAlertStudents;
